import LocationService from '@/domain/Location/LocationService';
import {
	Combobox,
	ComboboxContent,
	ComboboxEmpty,
	ComboboxInput,
	ComboboxItem,
	ComboboxList,
} from '@hydrodigital/combobox';
import type { ComboboxOption, ComboboxSize } from '@hydrodigital/combobox';
import { useEffect, useState } from 'react';

const locationService = new LocationService();

function parseLocations(locations: any[]): ComboboxOption[] {
	return locations.map((location: any) => ({
		value: String(location.locationId),
		label: location.locationName,
		children: location.childLocations ? parseLocations(location.childLocations) : [],
		disabled: !location.canShowLocation,
	}));
}

interface LocationComboboxProps {
	readonly value?: string | null;
	readonly onValueChange: (value: string | null) => void;
	readonly placeholder?: string;
	readonly size?: ComboboxSize;
	readonly label?: string;
	readonly searchable?: boolean;
}

export default function LocationCombobox({
	value,
	onValueChange,
	placeholder = 'Select Location',
	size = 'small',
	label,
	searchable = true,
}: Readonly<LocationComboboxProps>) {
	const [locations, setLocations] = useState<ComboboxOption[]>([]);

	useEffect(() => {
		const userId = localStorage.getItem('userId') || '';
		locationService.getLocationsByUser(userId).then((data) => {
			setLocations(parseLocations(data));
		});
	}, []);

	return (
		<div>
			{label && (
				<label className="block mb-1 text-sm font-medium">{label}</label>
			)}
			<Combobox
				items={locations}
				value={value ? String(value) : undefined}
				onValueChange={(val) => onValueChange(val)}
				onClear={() => onValueChange(null)}
				size={size}
				searchable={searchable}
			>
			<ComboboxInput placeholder={placeholder} />
			<ComboboxContent>
				<ComboboxEmpty>No locations found.</ComboboxEmpty>
				<ComboboxList>
					{(item) => (
						<ComboboxItem key={item.value} value={item}>
							{item.label}
						</ComboboxItem>
					)}
				</ComboboxList>
			</ComboboxContent>
		</Combobox>
		</div>
	);
}
